import React from 'react';
import PropTypes from 'prop-types';

import PopupV3, { PopupTypes } from '../../../../../components/Popup/PopupV3';
import RecurringEvents from '../OverviewTabContent/RecurringEvents';

import styles from './RecurringInfoPopup.module.scss';

function RecurringInfoPopup(props) {
    const {
        recurringEvents = [],
        showRecurringPopup,
        onConfirmClick,
        timeZone,
    } = props;

    const recurringInfoModalBody = (
        <div className={styles.recurringInfoPopupBody}>
            <div className={styles.recurringInfoTitle} data-testid="modal.recurring-info.title">This is a Recurring Event</div>
            <div className={styles.recurringInfoText} data-testid="modal.recurring-info.message">You registered for an event that is part of a recurring event series - interested in registering for the others ones?</div>
            <RecurringEvents
                recurrentEvents={recurringEvents}
                timeZone={timeZone}
                noPadding
            />
        </div>
    );

    return (
        <PopupV3
            message={recurringInfoModalBody}
            type={PopupTypes.INFO}
            isOpen={!!showRecurringPopup}
            onConfirmClick={onConfirmClick}
            confirmButtonLabel="Close"
            customContent
            noIcon
            className={styles.recurringInfoPopup}
            data-testid="modal.recurring-info"
        />
    );
}

RecurringInfoPopup.propTypes = {
    recurringEvents: PropTypes.arrayOf(PropTypes.object),
    showRecurringPopup: PropTypes.bool,
    onConfirmClick: PropTypes.func.isRequired,
    timeZone: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
};

RecurringInfoPopup.defaultProps = {
    recurringEvents: [],
    showRecurringPopup: false,
    timeZone: null,
};

export default RecurringInfoPopup;
